import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '@core/utils/http.utils';
import { Observable, map } from 'rxjs';
import { ReportResultGenerateRequest } from '@features/reports/models/results.model';
import { DataEndpoint } from '@core/models/general.model';

export interface ResultsDashboardResponse<T = any> {
  success?: boolean;
  data?: T;
  count?: number;
  Status?: number;
  Data?: T;
}

@Injectable({
  providedIn: 'root'
})
export class ResultsApi {
  private http = inject(HttpClient);
  private readonly RESULTS = '/Results';

  getResults(params: Record<string, any>): Observable<ResultsDashboardResponse<any[]>> {
    const url = `${this.RESULTS}`;
    const httpParams = HttpUtils.objectToHttpParams(params);
    return this.http.get<ResultsDashboardResponse<any[]>>(url, { params: httpParams });
  }

  getDashboard(params: Record<string, any>): Observable<ResultsDashboardResponse<any[]>> {
    const url = `${this.RESULTS}/dashboard`;
    const httpParams = HttpUtils.objectToHttpParams(params);
    return this.http.get<ResultsDashboardResponse<any[]>>(url, { params: httpParams });
  }

  getMonthlyEmissions(params: Record<string, any>): Observable<ResultsDashboardResponse<any>> {
    const url = `${this.RESULTS}/chart`;
    const httpParams = HttpUtils.objectToHttpParams(params);
    return this.http.get<ResultsDashboardResponse<any>>(url, { params: httpParams });
  }

  postGenerate(request: ReportResultGenerateRequest): Observable<DataEndpoint<any>> {
    const url = `${this.RESULTS}/generate`;

    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return { ...data }
      }));
  }

  getMonthlyResults(params: Record<string, any>): Observable<ResultsDashboardResponse<any>> {
    const url = `${this.RESULTS}/month`;
    const httpParams = HttpUtils.objectToHttpParams(params);
    return this.http.get<ResultsDashboardResponse<any>>(url, { params: httpParams });
  }
}
